var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
export var AccordionHeaderWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
export var AccordionIcon = styled(FontAwesomeIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: auto;\n"], ["\n  margin-left: auto;\n"])));
export var AccordionBodyWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  max-width: 650px;\n"], ["\n  max-width: 650px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
